import { useState, useEffect, useCallback } from 'react';

const KEY = 'ctg_compare';
export const MAX_COMPARE = 4;

const read = () => {
  try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
};
const emit = (list) => {
  localStorage.setItem(KEY, JSON.stringify(list));
  window.dispatchEvent(new CustomEvent('ctg-compare', { detail: list }));
};

export const useCompare = () => {
  const [slugs, setSlugs] = useState(read);

  useEffect(() => {
    const h = (e) => setSlugs(e.detail || read());
    window.addEventListener('ctg-compare', h);
    return () => window.removeEventListener('ctg-compare', h);
  }, []);

  const toggle = useCallback((slug) => {
    const cur = read();
    if (cur.includes(slug)) { emit(cur.filter((s) => s !== slug)); return true; }
    if (cur.length >= MAX_COMPARE) return false;
    emit([...cur, slug]);
    return true;
  }, []);

  const remove = useCallback((slug) => emit(read().filter((s) => s !== slug)), []);
  const clear = useCallback(() => emit([]), []);

  return { slugs, toggle, remove, clear, isSelected: (s) => slugs.includes(s), max: MAX_COMPARE };
};
